import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Accordion, useAccordionButton } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import SubMenuCandidateSelection from '../../components/menus/SubMenuCandidateSelection'
import { getActiveSelectionsByCandidate } from '../../actions/selectionsActions'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { changeCandidateStatus } from '../../actions/choosesActions'
import SelectionStatus from '../../components/selection/selectionStatus'

export default function ActiveProcesses() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {loading, selections} = useSelector(state => state.selections)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {result} = useSelector(state => state.chooses)

    const [selectedSelection, setSelectedSelection] = useState(null)

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleAcceptSelection = (selection) =>  {
        setSelectedSelection(selection)
        Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.candidateAcceptQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(changeCandidateStatus(selection?.choose?._id, 1))
            }
        })
    }

    const handleRejectSelection = (selection) =>  {
        setSelectedSelection(selection)
        Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.candidateRejectQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(changeCandidateStatus(selection?.choose?._id, 2))
            }
        })
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getActiveSelectionsByCandidate(client?.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    },[dispatch, t, client])

    useEffect(() => {
        if (result) {
            const selectedSelectionCopy = {...selectedSelection}
            setSelectedSelection(null)
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: false,
                confirmButtonText: t('global.great'),
                icon: 'success',
                text: t('selection.' + result)
            })
            if (result === "1candidateStatusSuccess") {
                navigate("/candidate/process/" + selectedSelectionCopy?._id)
            } else {
                dispatch(getActiveSelectionsByCandidate(client?.id))
            }
        }
    }, [result, dispatch, client, navigate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-5'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Procesos" />
                        <h1 className='ms-2 m-0'>{t('menus.candidateProcesses')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Row className='mb-5'>
                                    <Col>
                                        <h3>{t('menus.activeprocesses')}</h3>
                                    </Col>
                                </Row>
                                <SubMenuCandidateSelection section="activeProcesses"/>
                                {
                                    loading
                                    ?
                                        <div className='d-flex justify-content-center'>
                                            <span className="indicator-label">
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </div>
                                    :
                                        selections?.length > 0
                                        ?
                                        <>
                                            <Row className="d-none d-lg-block mt-3 border-bottom fw-bold">
                                                <Col className='d-flex'>
                                                    <div style={{width: "60%"}} className='py-2 ps-5'>{t("selection.title")}</div>
                                                    <div style={{width: "15%"}} className='py-2'>{t("selection.specialty")}</div>
                                                    <div style={{width: "15%"}} className='py-2'>{t("selection.subject")}</div>
                                                    <div style={{width: "10%"}} className='py-2 bg-grey text-center'>{t("global.actions")}</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='px-0'>
                                                    <Accordion>
                                                        {selections?.map((selection, selectionIndex) => (
                                                            <Card key={selectionIndex} className='my-2'>
                                                                <Card.Header className='px-0'>
                                                                    <Row className='w-100 mx-0 px-0'>
                                                                        <Col className='d-flex align-items-center px-0 mx-0'>
                                                                            <div style={{width: "5%"}} className='py-2 d-flex justify-content-center'><AccordionToggle eventKey={selectionIndex}><i className ='fas fa-chevron-right cursor d-block'></i></AccordionToggle></div>
                                                                            <div className='py-2' style={{width: window.innerWidth < 768 ? "85%" : "55%"}}>{selection.title}</div>
                                                                            <div style={{width: "15%"}} className='py-2 d-none d-lg-block'>{capitalizeFirstCharacter(levels?.find(l => l.id === selection.specialty)?.label)}</div>
                                                                            <div style={{width: "15%"}} className='py-2 d-none d-lg-block'>{t("subjects." + subjects?.find(s => s.id === selection.subject)?.label)}</div>
                                                                            <div style={{width: "10%"}} className='py-2 d-flex justify-content-center align-items-center '>
                                                                                {
                                                                                    !selection.choose?.candidateStatus &&
                                                                                    <>
                                                                                        <i className='fas fa-check cursor me-1' title={t("selection.acceptSelectionCandidate")} onClick={() => handleAcceptSelection(selection)}/>
                                                                                        <i className='fas fa-times cursor mx-1' title={t("selection.rejectSelectionCandidate")} onClick={() => handleRejectSelection(selection)}/>
                                                                                    </>
                                                                                }
                                                                                <Link to={`/candidate/process/${selection._id}`} className={`${!selection.choose?.candidateStatus ? 'ms-1' : ''}`}><img src='/images/eye.svg' alt='Ver'/></Link>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey={selectionIndex}>
                                                                    <Card.Body>
                                                                        <div>
                                                                            <h4 className='my-3'>{t("selection.status")}</h4>
                                                                            {
                                                                                selection.choose &&
                                                                                <SelectionStatus choose={selection.choose} selection={selection}/>
                                                                            }
                                                                        </div>
                                                                        <div>
                                                                            <h4 className='my-3'>{t("selection.offerSummary")}</h4>
                                                                            <Container className='cuadro-datos-generales'>
                                                                                {selection?.school?.name &&
                                                                                    <>
                                                                                        <Row className='py-3'>
                                                                                            <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                                <div className='title'>
                                                                                                    {t("users.name")}
                                                                                                </div>
                                                                                                <div className='data'>
                                                                                                    {selection?.school?.name}
                                                                                                    {
                                                                                                        selection?.school?.web
                                                                                                        ?
                                                                                                            <a href={selection?.school?.web} className='link' target="_blank" rel="noopener noreferrer">
                                                                                                                <i className='fas fa-globe ps-2'></i>
                                                                                                            </a>
                                                                                                        :
                                                                                                            <></>
                                                                                                    }
                                                                                                </div>
                                                                                            </Col>
                                                                                            <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                                <div className='title'>
                                                                                                    {t("users.address")}
                                                                                                </div>
                                                                                                <div className='data'>
                                                                                                    {selection?.school?.address}
                                                                                                </div>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </>
                                                                                }
                                                                                <Row className='py-3'>
                                                                                    <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                        <div className='title'>{t("selection.contractType")}</div>
                                                                                        <div className='data'>
                                                                                            {
                                                                                                selection?.fixedDiscontinuous
                                                                                                ?
                                                                                                    t('selection.fixedDiscontinuous')
                                                                                                :
                                                                                                    t('profile.candidate.'+selection?.contractType)
                                                                                            }
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                        <div className='title'>{t("profile.candidate.idealPosition.workDay.label")}</div>
                                                                                        <div className='data'>{t("profile.candidate.idealPosition.workDay." + selection.workdayType)}</div>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row className='py-3'>
                                                                                    <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                        <div className='title'>{t("users.province")}</div>
                                                                                        <div className='data'>{selection?.school?.province ? (provinces?.find(p => p.value === selection.school.province)?.label || '') : ''}</div>
                                                                                    </Col>
                                                                                    <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                        <div className='title'>{t("users.town")}</div>
                                                                                        <div className='data'>{selection?.school?.town ? (towns?.find(p => p.value === selection.school.town)?.label || '') : ''}</div>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row className='py-3'>
                                                                                    <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                        <div className='title'>{t("selection.shortIncorporationDate")}</div>
                                                                                        <div className='data'>{`${String(new Date(selection.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selection.incorporationDate).getFullYear()}`}</div>
                                                                                    </Col>
                                                                                    {
                                                                                        selection.distance !== null &&
                                                                                        <Col xs={12} md={6} className='d-flex justify-content-between'>
                                                                                            <div className='title'>{t("selection.distance")}</div>
                                                                                            <div className='data'>{selection.distance !== 0 && selection.distance !== "0" ? `${Math.trunc(Number(selection.distance))} km` : t("selection.zeroDistance")}</div>
                                                                                        </Col>
                                                                                    }
                                                                                </Row>
                                                                            </Container>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        ))}
                                                    </Accordion>
                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        <div className='text-center'>{t("selection.thereisnotprocess")}</div>

                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

function AccordionToggle({children, eventKey, callback}) {
    const handleAccordionToggle = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    )

    return (
        <span onClick={handleAccordionToggle} className='cursor'>{children}</span>
    )
}